import "core-js/modules/es.symbol";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { progressbarHasAccessibleName } from '@lmig/sales-ui-utilities';
import { CircularProgressTrack } from '@lmig/sales-ui-circular-progress-track';
import "./circularProgressSpinner.css";

var CircularProgressSpinner = function CircularProgressSpinner(_ref) {
  var id = _ref.id,
      size = _ref.size,
      variant = _ref.variant,
      hasTrack = _ref.hasTrack,
      className = _ref.className,
      ariaLabel = _ref['aria-label'],
      otherProps = _objectWithoutProperties(_ref, ["id", "size", "variant", "hasTrack", "className", "aria-label"]);

  var track = hasTrack !== undefined ? hasTrack : variant === 'teal' || variant === 'gray';
  return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
    "aria-label": ariaLabel,
    role: "progressbar",
    className: classNames('lms-CircularProgressSpinner', "lms-CircularProgressSpinner--".concat(size), "lms-CircularProgressSpinner--".concat(variant), className),
    id: id
  }), /*#__PURE__*/React.createElement(CircularProgressTrack, {
    size: size,
    variant: variant,
    hasTrack: track
  }));
};

CircularProgressSpinner.propTypes = {
  /** Add an optional ID to this element. */
  id: PropTypes.string,

  /** Sets the loader size and line weight. */
  size: PropTypes.oneOf(['16', '24', '32', '48', '64', '96']),

  /** Establishes the spinner's stroke color. The 'teal' and 'gray' variants add a track by default unless overriden using the hasTrack prop. */
  variant: PropTypes.oneOf(['teal', 'gray', 'dark', 'light']),

  /** The 'teal' and 'gray' spinner variants have a track while other variants do not. The hasTrack prop can be can be used to override these defaults. */
  hasTrack: PropTypes.bool,

  /** Add custom classes to this element. */
  className: PropTypes.string,

  /** Provide an accessible label with `aria-label` or `aria-labelledby`. */
  'aria-label': progressbarHasAccessibleName
};
CircularProgressSpinner.defaultProps = {
  id: undefined,
  size: '64',
  variant: 'teal',
  hasTrack: undefined,
  className: undefined,
  'aria-label': undefined
};
export default CircularProgressSpinner;